__turbopack_context__.v({
  "actions": "EmailVerificationReminder-module__qB1XbG__actions",
  "card": "EmailVerificationReminder-module__qB1XbG__card",
  "clip": "EmailVerificationReminder-module__qB1XbG__clip",
  "content": "EmailVerificationReminder-module__qB1XbG__content",
  "copy": "EmailVerificationReminder-module__qB1XbG__copy",
  "description": "EmailVerificationReminder-module__qB1XbG__description",
  "dismiss": "EmailVerificationReminder-module__qB1XbG__dismiss",
  "email": "EmailVerificationReminder-module__qB1XbG__email",
  "feedback": "EmailVerificationReminder-module__qB1XbG__feedback",
  "icon": "EmailVerificationReminder-module__qB1XbG__icon",
  "resend": "EmailVerificationReminder-module__qB1XbG__resend",
  "title": "EmailVerificationReminder-module__qB1XbG__title",
  "viewport": "EmailVerificationReminder-module__qB1XbG__viewport",
});
